import React from "react";
import { useSearchParams } from "react-router-dom";

interface SendButtonParams {
  audio: Blob;
  frameCommunicationSend: (arg: object) => void;
  setSending: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorSending: React.Dispatch<React.SetStateAction<boolean>>;
  setFileTooBig: React.Dispatch<React.SetStateAction<boolean>>;
  setSent: React.Dispatch<React.SetStateAction<boolean>>;
}

function SendButton({
  audio,
  frameCommunicationSend,
  setSending,
  setErrorSending,
  setFileTooBig,
  setSent,
}: SendButtonParams) {
  const [searchParams] = useSearchParams();

  const sendAudioFile = async () => {
    setSending(true);
    const data = new FormData();
    const rawDomain = searchParams.get("DOMAIN") ?? "";
    const domain = rawDomain.replace(/^https:\/\//, "").replace(/\/.*$/, "");
    const language = searchParams.get("LANG") ?? "en";

    data.append("audio", audio);
    data.append("domain", domain);

    if (audio.size > 104857600) {
      setErrorSending(true);
      setFileTooBig(true);
      setSending(false);
      return;
    }

    const url = process.env.REACT_APP_WHATSAPP_BACKEND_URL;

    try {
      const result = await fetch(`${url}/get_audio_url`, {
        method: "POST",
        body: data,
      });

      if (result.status === 200) {
        const resultBody = await result.json();
        const fileLink = resultBody.url;
        const message =
          language === "br"
            ? `[url=${fileLink}]🎵 PowerZap Áudio 🎵[/url]`
            : `[url=${fileLink}]🎵 PowerZap Audio 🎵[/url]`;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((window as any).BX24) {
          const bx24 = (window as any).BX24;
          const dialogId = bx24.placement.info().options?.dialogId;
          await bx24.callMethod(
            "im.message.add",
            { DIALOG_ID: dialogId, MESSAGE: message },
            (result: any) => {
              if (result.error()) {
                console.error("im.message.add falhou", result.error());
                setSending(false);
                setErrorSending(true);
              } else {
                setSending(false);
                setSent(true);
                // Best-effort: o widget se reinicia sozinho quando a janela não fecha.
                try {
                  bx24.closeApplication();
                } catch (e) {
                  /* empty */
                }
              }
            },
          );
        } else {
          frameCommunicationSend({
            action: "send",
            message,
          });
          frameCommunicationSend({ action: "close" });
          setSending(false);
          setSent(true);
        }
      } else {
        console.error("upload do áudio falhou", result.status);
        if (result.status === 413) {
          setFileTooBig(true);
        }
        setSending(false);
        setErrorSending(true);
      }
    } catch (error) {
      console.error("envio do áudio falhou", error);
      setSending(false);
      setErrorSending(true);
    }
  };

  return (
    <div>
      <button
        className="bg-primary-pure rounded-full p-2 text-white mx-1"
        onClick={sendAudioFile}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
          />
        </svg>
      </button>
    </div>
  );
}

export default SendButton;
